<div class="box-parent scrollable">
  <div style="display: block">
    <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
      [chartType]="barChartType">
    </canvas>
  </div>
</div>


// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-download-stat/dashboard-download-stat.component.html